import CATEGORIES from '@constants/categories'

export function makeOfferCatalog (type, query, offerListItems) {
    return [{
        "@context": "http://schema.org",
        "@type": "OfferCatalog",
        "name": `Oferty ${makeOfferCatalogName(type, query)}`.trim(),
        "itemListElement": offerListItems,
    }]
}

function makeOfferCatalogName (type, query) {
    if (!query) return ''
    const title = [query.marka, query.model, query['nazwa-czesci'], query.fraza, query.tytul].filter(Boolean).join(' ').trim()
    return title
        ? title
        : (CATEGORIES[type] || '').toLowerCase()
}

export {
    makeOfferCatalogName,
}
